(function () {
  'use strict';
  /**
   * @ngdoc service
   * @name itecAdministracio.api.entitat.factory:EntitatFactory
   *
   * @description
   *
   */
  angular
    .module('itecAdministracio.api.aplicacio')
    .factory('AplicacioFactory', AplicacioFactory);
  function AplicacioFactory(AdmConstant, DataFactory) {
    var api = AdmConstant.SERVER_PATH_ADMINISTRACIO + 'aplicacions';

    var AplicacioBase = {

      getAll: function(form){
        var url = api;
        return DataFactory.getWithParams(url, form);
      },
      get: function(id){
        var url = api + '/' + id;
        return DataFactory.get(url);
      },
      getAplicacionsProducte: function(idproducte,identitat){
        var url = api;
        return DataFactory.getWithParams(url, {"idproducte":idproducte,"identitat":identitat});
      }
    };
    return AplicacioBase;
  }
}());
